<template>
    <div :class="{'bg-checkered': isOpacitySet || hasColorTransparency}">
        <div :style="elementStyle" />
    </div>
</template>

<script>
export default {
    props: {
        /** @type {PublishElementDataCommon | PublishElementDataEmptyRectangle} */
        data: Object
    },
    computed: {
        opacity() {
            const transparencyPercentage = +this.data.transparency // +null is 0
            return transparencyPercentage ? (100 - transparencyPercentage) / 100 : 1
        },
        isOpacitySet() {
            return this.opacity < 1
        },
        hasColorTransparency() {
            return this.data.primary_color.length > 7
        },
        /** @returns {Partial<CSSStyleDeclaration>}*/
        elementStyle() {
            return {
                backgroundColor: this.data.primary_color,
                opacity: this.isOpacitySet ? this.opacity : 'unset',
                height: '100%'
            }
        }
    }
}
</script>
